var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M7.5 2.094a6.406 6.406 0 1 1 0 12.812 6.406 6.406 0 0 1 0-12.812zm.01 1.392-.19.005a4.979 4.979 0 0 0-3.344 1.487 4.982 4.982 0 1 0 7.048 7.044 4.983 4.983 0 0 0-3.325-8.533l-.19-.003zM7.5 7.458c.485 0 .878.393.878.878v2.862a.878.878 0 1 1-1.756 0V8.336c0-.485.393-.878.878-.878zm0-2.524a1.024 1.024 0 1 1 0 2.049 1.024 1.024 0 0 1 0-2.049z"
  })));
};

export default SvgInfo;